import { Skeleton, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { Table } from '../../patient-profile-page.styles';

const NotesTableSkeleton = () => (
  <Table>
    <TableHead>
      <TableRow>
        <TableCell sx={{ width: '15%' }}>Date</TableCell>
        <TableCell>Response</TableCell>
        <TableCell sx={{ width: '15%' }}>Author</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {[...Array(5)].map((_, index) => (
        <TableRow key={index}>
          <TableCell style={{ width: '15%' }}>
            <Skeleton variant="text" width={80} height={20} />
          </TableCell>
          <TableCell>
            <Skeleton variant="text" width="80%" height={20} />
          </TableCell>
          <TableCell style={{ width: '15%' }}>
            <Skeleton variant="text" width={100} height={20} />
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);

export default NotesTableSkeleton;
